<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span>Stacked Decks</h1>
<h1 class="bk1">Building Inspectors and the Reproduction of Urban Inequality</h1>
<p class="bkau"><span class="sm">ROBIN</span> <span class="sm">BARTRAM</span></p>
<p class="bkpub"><span class="sm">THE</span> <span class="sm">UNIVERSITY</span> <span class="sm">OF</span> <span class="sm">CHICAGO</span> <span class="sm">PRESS</span></p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">AND</span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-bartram-0003.vue?3be2cc4a